import * as Sentry from '@sentry/angular';
import { environment } from '@jepto/environments/environment';
import { appendSentryLogDetail, safeStringify } from './safe-stringify';

/** Append serialised args so Sentry log search matches error text, not only the alias. */
function sentryLogMessage(alias: string, args: unknown[]): string {
	if (args.length === 0) {
		return alias;
	}
	const detail = args.map(arg => safeStringify(arg)).join('; ');
	return appendSentryLogDetail(alias, detail);
}

/** Non-production debug logging only. Does not redact `args` — never pass PII or secrets. */
export const log = (alias?: any, ...args: any[]): void => {
	if (!environment.production) {
		if (args.length > 0) {
			console.log('DEBUG: ' + alias, ...args);
		} else {
			console.log('DEBUG: ' + alias);
		}
	}
};

export const error = (alias: string, ...args: any[]): void => {
	if (args.length > 0) {
		console.error('ERROR: ' + alias, ...args);
	} else {
		console.error('ERROR: ' + alias);
	}
	try {
		if (Sentry.logger) {
			Sentry.logger.error(sentryLogMessage(alias, args), {
				args: args.length > 0 ? safeStringify(args) : undefined,
				source: 'logger.error',
			});
		}
	} catch {
		// Swallow to avoid breaking callers
	}
};

export const warn = (alias: string, ...args: any[]): void => {
	if (args.length > 0) {
		console.warn('WARN: ' + alias, ...args);
	} else {
		console.warn('WARN: ' + alias);
	}
	try {
		if (Sentry.logger) {
			Sentry.logger.warn(sentryLogMessage(alias, args), {
				args: args.length > 0 ? safeStringify(args) : undefined,
				source: 'logger.warn',
			});
		}
	} catch {
		// Swallow to avoid breaking callers
	}
};
